module.exports = __webpack_public_path__ + "img/black-frame-middle-shadowed-100.5be1f12b.png";